var React = require('react');

function Sending (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","fill":"#1A5AD1","key":0}),React.createElement("path",{"d":"M14.5714 24L21 9L6 15.4286L13.8571 16.1429L14.5714 24Z","fill":"white","key":1})]);
}

Sending.defaultProps = {"viewBox":"0 0 30 30","fill":"none"};

module.exports = Sending;

Sending.default = Sending;
